import Vue from 'vue'
import Vuetify, {VApp, VContainer, VFlex} from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  icons: 'fa',
  components: {
    VApp,
    VContainer,
    VFlex
  }
})

